import { render, staticRenderFns } from "./OrdersPD.vue?vue&type=template&id=5e188362"
import script from "./OrdersPD.vue?vue&type=script&lang=js"
export * from "./OrdersPD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports